// extracted by mini-css-extract-plugin
export default {"wrapper":"Az-z","viewport":"Bz-z","container":"Cz-z","slide":"Dz-z"};